<template>
  <v-container id="mainCalendar" class="pa-0">
    <v-layout v-if="!routes" wrap align-content-start fill-height>
      <!-- In case you have no routes this day, let the user know when they do have. -->
      <v-flex xs12 class="desc-text hwayzBlack text-xs-center pa-3">
        You have no routes scheduled.
      </v-flex>
      <v-flex xs12 class="hwayzGray text-xs-center px-4" v-html="messageNoRoutes" />
    </v-layout>
    <v-layout v-else wrap align-content-start fill-height>
      <v-flex
        xs12
        class="desc-text hwayzGray text-xs-center pa-3"
      >
        You have {{ routes.length }} routes on this day.
      </v-flex>
      <v-flex
        v-for="event in routes"
        :key="event.id"
        v-ripple
        xs12
        class="row-event"
        @click="$emit('click-to-expand', event._id)"
      >
        <v-layout align-center class="pa-3">
          <v-flex class="text-xs-left">
            <div>
              {{ event.clientName.toUpperCase() }} - {{ event.name }}
              <br>
              Starts at: {{ event.startTime | getTime }}
            </div>
            <div class="hwayzGray">
              {{ event.routeStops.length }} showings
            </div>
          </v-flex>
          <v-flex shrink>
            <v-icon>chevron_right</v-icon>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment'

export default {
  filters: {
    dateWithDay(val) {
      return val ? moment(val).format('dddd, MMMM Do YYYY, hh:mm') : ''
    },
    getTime(val) {
      return moment(val).format('hh:mm A')
    }
  },

  props: {
    routes: {
      type: Array,
      default: () => []
    },
    selectedDate: {
      type: String,
      required: true
    },
    messageNoRoutes: {
      type: String,
      required: true
    }
  },

  data: () => ({
    allRoutesShowing: true,
    singleRouteShowing: false
  })
}
</script>

<style lang="sass" scoped>
.row-event
  font-size: 1.8rem
  height: fit-content;
  background-color: $hwayzBackgroundColor
  border-bottom: solid 4px $hwayzWhite
  .v-icon
    font-size: 3.5rem !important

.desc-text
    font-size: 1.8rem

.hwayzGray
  color: $hwayzDarkGray

.hwayzBlack
  color: $hwayzBlack
</style>
